<h1>{{ 'payments.payment-success' | translate }}</h1>

<p [innerHTML]="'payments.payment-success-text' | translate: { 'newBalance': newBalance | currency:currencyCode:'symbol':'1.0-2':localeID | hgReplaceCurrencyCode:currencyCode } | hgSafeHtml"></p>

<button class="default-btn" [routerLink]="['/']">
    <span>{{ 'general.alerts.ok-btn' | translate }}</span>
</button>
